import SetCurrentComponent from "@/core/services/SetCurrentComponent";
import { historico_de_informacao_do_aluno } from "./historico-de-informacao-do-aluno";
const cadastro_de_aluno = {
  path: "/cadastro-de-aluno",
  redirect: "/cadastro-de-aluno",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Manutenção de Aluno",
  },
  children: [
    {
      path: "/cadastro-de-aluno",
      name: "cadastro_de_aluno",
      meta: {
        allowedPermissions: ["pesquisar_aluno_personalizada"],
      },
      component: SetCurrentComponent("CadastroDeAluno", "CadastroDeAlunoHome"),
    },
    {
      path: "/cadastro-de-aluno/novo",
      name: "cadastro_de_aluno_cad",
      meta: {
        allowedPermissions: ["cadastro_aluno"],
      },
      component: SetCurrentComponent("CadastroDeAluno", "CadastroDeAlunoCad"),
    },
    {
      path: "/cadastro-de-aluno/edit/:id",
      name: "cadastro_de_aluno_atualizar",
      meta: {
        allowedPermissions: ["aluno_edit"],
      },
      component: SetCurrentComponent("CadastroDeAluno", "CadastroDeAlunoEdit"),
    },
    {
      path: "/cadastro-de-aluno/visualizar/:id",
      name: "cadastro_de_aluno_visualizar",
      meta: {
        allowedPermissions: ["aluno_show"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno",
        "CadastroDeAlunoVisualizar"
      ),
    },
    {
      path: "/cadastro-de-aluno/editar-dados/:id",
      name: "cadastro_de_aluno_editar_dados",
      meta: {
        allowedPermissions: ["aluno_edit"],
      },
      component: SetCurrentComponent("CadastroDeAluno", "CadastroDeAlunoEdit"),
    },
    {
      path: "/cadastro-de-aluno/editar-dados-complementares/:id",
      name: "cadastro_de_aluno_editar_dados_complementares",
      meta: {
        allowedPermissions: ["aluno_edit_complementares"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/EditarDadosComplementaresDoAluno",
        "EditarDadosComplementaresDoAluno"
      ),
    },
    {
      path: "/cadastro-de-aluno/indigena/:id",
      name: "cadastro_de_aluno_indigena",
      meta: {
        allowedPermissions: ["aluno_indigena_alterar_dados"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/CadastroDeDadosDeAlunoIndigena",
        "CadastroDeDadosDeAlunoIndigenaCad"
      ),
    },
    {
      path: "/cadastro-de-aluno/ficha-de-saude-do-aluno/:id",
      name: "ficha_de_saude_do_aluno",
      meta: {
        allowedPermissions: ["aluno_atualizar_ficha_saude"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/FichaDeSaudeDoAluno",
        "FichaDeSaudeDoAluno"
      ),
    },
    {
      path: "/cadastro-de-aluno/informar-alunos-irmaos/:id",
      name: "informar_alunos_irmaos",
      meta: {
        allowedPermissions: ["criar_dados_irmao"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/InformarAlunosIrmaoGemeos",
        "InformarAlunosIrmaoGemeos"
      ),
    },
    {
      path: "/cadastro-de-aluno/edicao-nome-do-aluno/:id",
      name: "edicao_nome_aluno",
      meta: {
        allowedPermissions: ["alterar_dados_aluno"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/NomeAluno",
        "NomeAluno"
      ),
    },
    {
      path: "/cadastro-de-aluno/manutencao-do-codigo-inep-do-aluno/:id",
      name: "manutencao_do_codigo_inep_do_aluno",
      meta: {
        allowedPermissions: ["alterar_dados_aluno"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/ManutencaoDoCodigoInepDoAluno",
        "ManutencaoDoCodigoInepDoAluno"
      ),
    },
    {
      path: "/cadastro-de-aluno/historico-de-matricula-do-aluno/:id",
      name: "historico_de_matricula_do_aluno",
      meta: {
        allowedPermissions: ["listar_escolaridade_anterior"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/HistoricoDeMatriculaDoAluno",
        "index"
      ),
    },
    {
      path: "/cadastro-de-aluno/historico-de-matricula-do-aluno/:baseId/:destinoId",
      name: "historico_de_matricula_do_aluno_visualizar",
      meta: {
        allowedPermissions: ["listar_escolaridade_anterior_aluno"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/HistoricoDeMatriculaDoAluno",
        "Visualizar"
      ),
    },
    ...historico_de_informacao_do_aluno,
    {
      path: "/cadastro-de-aluno/edicao-de-endereco-do-aluno/:id",
      name: "edicao_de_endereco_do_aluno",
      meta: {
        allowedPermissions: ["alterar_endereco_aluno"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/EnderecoAluno",
        "EnderecoAluno"
      ),
    },
  ],
};

export { cadastro_de_aluno };
